"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.relatedCases = exports.relatedCase = void 0;
exports.relatedCase = {
    case_id: 29914,
    case_status: "In Progress",
    facility: "HFM",
    process_instance_guid: "0e0543f4-1903-4abf-b583-fa99665b39e9",
    case_uid: "a13107c6-907b-4a66-86f9-1652583d2d47",
    date_of_service: "2023-05-03",
    datetime_of_service: "2023-05-03 17:17:43 EDT",
    patient_class: "INPATIENT",
    performing_provider_name: null,
    billing_provider_name: null,
    note_specialty_designation: null,
    cci_edit_indicator: null,
    automated_indicator: null,
    process_status: null,
    pre_prediction_process_reason: null,
    rules: null,
    claims_edit_indicator: null,
    post_prediction_process_reason: null,
    service_line: "IPC",
    primary_activity_provider_name: "PA1",
    note_final_sign_provider_name: "FS1",
    note_final_sign_provider_number: null,
    primary_activity_provider_number: null,
    notes: [],
    coding_status: {
        is_chargeable: true,
        process_instance_status: "NEW",
        hold_status: "HOLD",
        hold_comment: "",
        qa_status: null,
        is_cancelled: false
    }
};
exports.relatedCases = [
    {
        tenant_code: "HFH",
        tenant_name: "Henry Ford Main Campus",
        health_system_code: "HFHS",
        tenant_uid: "b5f41b81-a75c-40cc-a8cb-5cad2aff35cb",
        tenant_timezone: "America/New_York",
        version: "2.0",
        case_json_id: 27783,
        case_id: 29914,
        case_status: "In Progress",
        process_instance_id: 27783,
        process_instance_guid: "0e0543f4-1903-4abf-b583-fa99665b39e9",
        case_encounter_id: 3836,
        encounter_uid: "da07120b-679b-4248-aac0-d1ec60c896d6",
        process_uid: "597ad270-c20a-44d5-882e-b2b2eed6d2f5",
        case_uid: "a13107c6-907b-4a66-86f9-1652583d2d47",
        caserun_uid: "0e0543f4-1903-4abf-b583-fa99665b39e9",
        date_of_service: "2023-05-03",
        datetime_of_service: "2023-05-03 17:17:43 EDT",
        source_type: "hl7",
        service_line: "IPC",
        patient_class: "INPATIENT",
        patient_type: null,
        performing_provider_specialty: null,
        performing_provider_name: null,
        performing_provider_number: {
            number: null,
            issuer: null,
            type: null
        },
        billing_provider_specialty: null,
        billing_provider_name: null,
        billing_provider_number: {
            number: null,
            issuer: "EPIC",
            type: "PROVID"
        },
        note_specialty_designation: null,
        primary_activity_provider_name: "PA1",
        note_final_sign_provider_name: "FS1",
        note_final_sign_provider_number: null,
        primary_activity_provider_number: null,
        notes: []
    },
    {
        tenant_code: "HFH",
        tenant_name: "Henry Ford Main Campus",
        health_system_code: "HFHS",
        tenant_uid: "b5f41b81-a75c-40cc-a8cb-5cad2aff35cb",
        tenant_timezone: "America/New_York",
        version: "2.0",
        case_json_id: 32436,
        case_id: 34623,
        case_status: "Manual",
        process_instance_id: 32436,
        process_instance_guid: "706f50f1-b589-4d90-bdaf-444e40efa0f9",
        case_encounter_id: 3836,
        encounter_uid: "da07120b-679b-4248-aac0-d1ec60c896d6",
        process_uid: "4b04865d-d2d4-4c74-8755-98dae422ddcc",
        case_uid: "fe487f81-aa0c-4d88-add2-9c6c2b480737",
        caserun_uid: "706f50f1-b589-4d90-bdaf-444e40efa0f9",
        date_of_service: "2023-05-02",
        datetime_of_service: "2023-05-02 07:58:30 EDT",
        source_type: "hl7",
        service_line: "IPC",
        patient_class: "INPATIENT",
        patient_type: null,
        performing_provider_specialty: null,
        performing_provider_name: null,
        performing_provider_number: {
            number: null,
            issuer: null,
            type: null
        },
        billing_provider_specialty: null,
        billing_provider_name: null,
        billing_provider_number: {
            number: null,
            issuer: "EPIC",
            type: "PROVID"
        },
        note_specialty_designation: null,
        primary_activity_provider_name: "PA2",
        note_final_sign_provider_name: "FS2",
        note_final_sign_provider_number: null,
        primary_activity_provider_number: null,
        notes: [],
        coding_status: {
            is_chargeable: true,
            process_instance_status: "NEW",
            hold_status: "HOLD",
            hold_comment: "",
            qa_status: null,
            is_cancelled: false
        }
    },
    {
        tenant_code: "HFH",
        tenant_name: "Henry Ford Main Campus",
        health_system_code: "HFHS",
        tenant_uid: "b5f41b81-a75c-40cc-a8cb-5cad2aff35cb",
        tenant_timezone: "America/New_York",
        version: "2.0",
        case_json_id: 27533,
        case_id: 29663,
        case_status: "Automated",
        process_instance_id: 27533,
        process_instance_guid: "92f8c44c-167a-43b7-90d4-00e82643650b",
        case_encounter_id: 3836,
        encounter_uid: "da07120b-679b-4248-aac0-d1ec60c896d6",
        process_uid: "d0ddbe21-8a41-4c28-801b-e7d35efcc6b3",
        case_uid: "27fb94cc-09ff-4cc1-8fbd-3492a2bcdcbf",
        caserun_uid: "92f8c44c-167a-43b7-90d4-00e82643650b",
        date_of_service: "2023-04-29",
        datetime_of_service: "2023-04-29 09:01:40 EDT",
        source_type: "hl7",
        service_line: "IPC",
        patient_class: "INPATIENT",
        patient_type: null,
        performing_provider_specialty: null,
        performing_provider_name: null,
        performing_provider_number: {
            number: null,
            issuer: null,
            type: null
        },
        billing_provider_specialty: null,
        billing_provider_name: null,
        billing_provider_number: {
            number: null,
            issuer: "EPIC",
            type: "PROVID"
        },
        note_specialty_designation: "Internal Medicine",
        primary_activity_provider_name: "PA3",
        note_final_sign_provider_name: "FS3",
        note_final_sign_provider_number: null,
        primary_activity_provider_number: null,
        notes: [],
        coding_status: {
            is_chargeable: true,
            process_instance_status: "NEW",
            hold_status: "HOLD",
            hold_comment: "",
            qa_status: null,
            is_cancelled: false
        }
    },
    {
        tenant_code: "HFH",
        tenant_name: "Henry Ford Main Campus",
        health_system_code: "HFHS",
        tenant_uid: "b5f41b81-a75c-40cc-a8cb-5cad2aff35cb",
        tenant_timezone: "America/New_York",
        version: "2.0",
        case_json_id: 27766,
        case_id: 29894,
        case_status: "In Progress",
        process_instance_id: 27766,
        process_instance_guid: "ce1b676f-614f-45e1-af8b-9a1dc7177801",
        case_encounter_id: 3836,
        encounter_uid: "da07120b-679b-4248-aac0-d1ec60c896d6",
        process_uid: "3e9beb3a-6b6a-48a9-91a3-b9115c04c958",
        case_uid: "72c45d47-56f8-4d20-9dcd-263d08a0c9a6",
        caserun_uid: "ce1b676f-614f-45e1-af8b-9a1dc7177801",
        date_of_service: "2023-05-02",
        datetime_of_service: "2023-05-02 15:05:19 EDT",
        source_type: "hl7",
        service_line: "IPC",
        patient_class: "INPATIENT",
        patient_type: null,
        performing_provider_specialty: null,
        performing_provider_name: null,
        performing_provider_number: {
            number: null,
            issuer: null,
            type: null
        },
        billing_provider_specialty: null,
        billing_provider_name: null,
        billing_provider_number: {
            number: null,
            issuer: "EPIC",
            type: "PROVID"
        },
        note_specialty_designation: "Nursing",
        primary_activity_provider_name: null,
        note_final_sign_provider_name: null,
        note_final_sign_provider_number: null,
        primary_activity_provider_number: null,
        notes: [],
        coding_status: {
            is_chargeable: true,
            process_instance_status: "NEW",
            hold_status: "HOLD",
            hold_comment: "",
            qa_status: null,
            is_cancelled: false
        }
    }
];
//# sourceMappingURL=related-cases.js.map